import React, { Fragment } from 'react';

import { FieldArray, Formik } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import CheckboxFormField from 'CommonComponents/CheckboxFormField';
import TextFormField from 'CommonComponents/TextFormField';
import Toast from 'CommonComponents/Toast';

import TrashIcon from 'Assets/icons/trash.svg';

const DEFAULT_SCHEDULE_TYPE = { id: null, is_medal: false, name: '' };
const ScheduleTypes = Yup.object().shape({
    schedule_types: Yup.array().of(
        Yup.object().shape({
            name: Yup.string().required('This value is required'),
            is_medal: Yup.boolean(),
        }),
    ),
});

export default function SessionTypesTable(props) {
    const onDelete = (scheduleTypeId) => {
        const url = props.deleteScheduleTypeUrl.replace('SCHEDULE_TYPE_ID', scheduleTypeId);

        axios
            .delete(url)
            .then(() => {
                props.onRefetch();
                $('#schedule-type-delete-success-toast').toast('show');
            })
            .catch(() => {
                $('#schedule-type-delete-fail-toast').toast('show');
            });
    };

    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={{
                    schedule_types: props.scheduleTypes?.map(({ id, name, is_medal }) => ({ id, name, is_medal })) || [],
                }}
                validationSchema={ScheduleTypes}
                onSubmit={(values, actions) => {
                    axios
                        .put(props.upsertScheduleTypesUrl, { schedule_types: values.schedule_types })
                        .then(() => {
                            props.onRefetch();
                            $('#schedule-types-update-success-toast').toast('show');
                        })
                        .catch((e) => {
                            actions.setErrors(e.response.data.errors);
                            $('#schedule-types-update-fail-toast').toast('show');
                            actions.setSubmitting(false);
                        });
                }}
            >
                {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                    <div className="table__card">
                        <FieldArray
                            name="schedule_types"
                            render={(arrayHelpers) => (
                                <Fragment>
                                    <div className="tw-flex tw-justify-between tw-items-center tw-mb-6">
                                        <h4 className="table__header">{$t('Session Type')}</h4>
                                        <div className={'tw-flex tw-justify-end tw-items-center tw-gap-1.5'}>
                                            <Button variant="primary" onClick={() => arrayHelpers.push(DEFAULT_SCHEDULE_TYPE)}>
                                                {$t('Create New Session Type')}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="inbud-table_wrapper">
                                        <table className="inbud-table">
                                            <thead>
                                                <tr>
                                                    <th className="tw-w-20">{$t('Medal')}</th>
                                                    <th>{$t('Name')}</th>
                                                    <th className="tw-w-20">{$t('Actions')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {values.schedule_types?.length ? (
                                                    values.schedule_types.map((scheduleType, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <CheckboxFormField
                                                                        type="checkbox"
                                                                        name={`schedule_types.${index}.is_medal`}
                                                                        id={`schedule_types_${index}_is_medal`}
                                                                    ></CheckboxFormField>
                                                                </td>
                                                                <td>
                                                                    <TextFormField
                                                                        hideLabel
                                                                        name={`schedule_types.${index}.name`}
                                                                        placeholder={$t('Name')}
                                                                    ></TextFormField>
                                                                </td>
                                                                <td>
                                                                    <button className="tw-text-red" onClick={(e) => onDelete(values.schedule_types[index].id)}>
                                                                        <TrashIcon className="tw-w-3 tw-h-3" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={100}>{$t('No session types added yet')}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </Fragment>
                            )}
                        />
                        <div className="tw-mt-6 tw-flex tw-justify-end">
                            <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                                {$t('Save')}
                            </Button>
                        </div>
                    </div>
                )}
            </Formik>

            <Toast id="schedule-types-update-success-toast" message={$t('Schedule types updated successfully')} />
            <Toast id="schedule-types-update-fail-toast" message={$t('Schedule types update failed')} />
            <Toast id="schedule-type-delete-success-toast" message={$t('Schedule type deleted successfully')} />
            <Toast id="schedule-type-delete-fail-toast" message={$t('Schedule type delete failed')} />
        </div>
    );
}
